import React from "react";
import './LoadingIndicator.scss';

const LoadingIndicator = () => {
    return (
        <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    );
};

export default LoadingIndicator;